export default {
  ru: {
    badTitle: 'Вы выбрали «Плохо!»',
    fineTitle: 'Вы выбрали «Средне…»',
    greatTitle: 'Вы выбрали «Отлично!»',
    shortThanks: 'Спасибо!',
    longThanks: 'Спасибо, ваш отзыв очень важен для нас!',
    respect: 'Вы помогаете делать нашу работу лучше',
    addFeedback: 'Хотите записать свой отзыв?',
    badScore: '«Плохо!»',
    fineScore: '«Средне…»',
    greatScore: '«Отлично!»',
    question: 'Хотите оставить такую обратную связь?',
    agree: 'Да, подтвердить',
    disagree: 'Нет, отменить',
    yes: 'Да',
    no: 'Нет',
    goHome: 'На главную',
    badHardware: 'Ошибка отправки',
    notPossible: 'По техническим причинам отправка невозможна',
    emailSubject: 'Promobot отзыв',
    emailbody: 'Был оставлен отзыв: {score}',
  },
  en: {
    // en
  },
};
